
  import { css } from 'lit';
  export const styles = css`:host{--background: var(--ig-dialog-background, var(--ig-gray-900-contrast));--message-color: var(--ig-dialog-message-color, var(--ig-gray-700));--border-radius: var(--ig-dialog-border-radius, clamp(0rem, calc(var(--ig-radius-factor, 0.2777777778) * 2.25rem), 2.25rem));--ig-theme: indigo;--ig-theme-variant: light}`;
  